module.exports = __webpack_public_path__ + "static/media/moons_comer_brackets-375.1c6cfef5.jpg";